var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeasuringTape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2556_2272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.817 52.165V64.756C137.41 62.8638 140 60.7254 140 58.4606C140 56.1962 137.41 54.0575 132.817 52.165Z",
    fill: "url(#paint0_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2489 54.0893C104.389 54.0893 134.498 49.4201 134.498 43.6603C134.498 37.9006 104.389 33.2314 67.2489 33.2314C30.1083 33.2314 0 37.9006 0 43.6603C0 49.4201 30.1083 54.0893 67.2489 54.0893Z",
    fill: "url(#paint1_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2489 34.0455C97.8057 34.0455 122.577 30.2039 122.577 25.4651C122.577 20.7263 97.8057 16.8848 67.2489 16.8848C36.6921 16.8848 11.9209 20.7263 11.9209 25.4651C11.9209 30.2039 36.6921 34.0455 67.2489 34.0455Z",
    fill: "url(#paint2_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6377 34.0441C66.8417 34.0444 67.0445 34.0452 67.249 34.0452C71.8062 34.0452 76.2329 33.959 80.4697 33.7981V17.1318C76.2329 16.9707 71.8062 16.8848 67.249 16.8848C67.0445 16.8848 66.8417 16.8856 66.6377 16.8859V34.0441Z",
    fill: "url(#paint3_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1625 38.1499H64.6117C66.0682 38.1499 67.2489 36.9693 67.2489 35.5127V17.481C67.2489 15.9761 65.9895 14.7754 64.4862 14.8457C35.2131 16.2103 11.9209 20.8698 11.9209 25.4651C11.9209 28.2097 20.2314 36.09 33.1625 38.1499Z",
    fill: "url(#paint4_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4863 14.8457C57.0457 15.1924 49.9933 15.7527 43.6099 16.47V38.1497H64.6121C66.0686 38.1497 67.2493 36.969 67.2493 35.5124V17.481C67.249 15.9761 65.9898 14.7757 64.4863 14.8457Z",
    fill: "url(#paint5_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8541 39.177H65.1153C64.3241 39.177 63.6826 38.5354 63.6826 37.7443V15.2383C63.6826 14.4472 64.3241 13.8057 65.1153 13.8057H67.8541C68.6452 13.8057 69.2867 14.4472 69.2867 15.2383V37.7446C69.2867 38.5357 68.6452 39.177 67.8541 39.177Z",
    fill: "url(#paint6_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2489 34.0452C36.6921 34.0452 11.9209 30.2037 11.9209 25.4648V55.6436C11.9209 60.3825 36.6921 64.224 67.2489 64.224C97.8057 64.224 122.577 60.3825 122.577 55.6436V25.4651C122.577 30.2037 97.8057 34.0452 67.2489 34.0452Z",
    fill: "url(#paint7_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9209 44.8301V55.6441C11.9209 60.3827 36.6921 64.2245 67.2489 64.2245C97.8057 64.2245 122.577 60.383 122.577 55.6441V44.8301H11.9209Z",
    fill: "url(#paint8_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8982 48.0075V58.4392C26.6728 58.1976 24.5453 57.9379 22.5247 57.6565V47.9996C22.5247 46.1087 24.1747 44.642 26.0518 44.8677C26.0732 44.8702 26.0947 44.8729 26.1161 44.8754C27.7022 45.0659 28.8982 46.4104 28.8982 48.0075Z",
    fill: "url(#paint9_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.515 49.4752V59.7449C43.3387 59.6288 41.211 59.4973 39.1384 59.3474V49.4711C39.1384 47.6547 40.6677 46.2108 42.4806 46.3225C42.5028 46.3239 42.5253 46.3252 42.5476 46.3266C44.2136 46.429 45.515 47.8062 45.515 49.4752Z",
    fill: "url(#paint10_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1288 50.1294V60.2701C59.9736 60.2457 57.8462 60.2059 55.7522 60.1479V50.1283C55.7522 48.3651 57.1975 46.941 58.9604 46.9742C58.9826 46.9748 59.0051 46.975 59.0274 46.9756C60.7485 47.0077 62.1288 48.408 62.1288 50.1294Z",
    fill: "url(#paint11_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7457 50.1283V60.1479C76.6518 60.2061 74.5243 60.2457 72.3691 60.2701V50.1294C72.3691 48.4083 73.7494 47.0077 75.4703 46.9756C75.4925 46.975 75.515 46.9748 75.5373 46.9742C77.3004 46.9407 78.7457 48.3649 78.7457 50.1283Z",
    fill: "url(#paint12_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3593 49.4711V59.3474C93.2867 59.4973 91.1593 59.6285 88.9827 59.7449V49.4752C88.9827 47.8062 90.2841 46.429 91.9501 46.3266C91.9724 46.3252 91.9949 46.3239 92.0171 46.3225C93.83 46.2108 95.3593 47.6547 95.3593 49.4711Z",
    fill: "url(#paint13_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.973 48.0003V57.6572C109.952 57.9386 107.825 58.1983 105.599 58.4399V48.0082C105.599 46.4109 106.795 45.0666 108.382 44.8763C108.403 44.8739 108.424 44.8711 108.446 44.8687C110.323 44.643 111.973 46.1097 111.973 48.0003Z",
    fill: "url(#paint14_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2489 54.0891C30.1082 54.0891 0 49.4199 0 43.6602V80.3413C0 86.101 30.1082 90.7702 67.2489 90.7702C104.389 90.7702 134.498 86.101 134.498 80.3413V43.6602C134.498 49.4199 104.389 54.0891 67.2489 54.0891Z",
    fill: "url(#paint15_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2488 54.0891C66.0525 54.0891 64.8636 54.0841 63.6826 54.0745V90.7556C64.8636 90.7652 66.0525 90.7702 67.2488 90.7702C104.389 90.7702 134.498 86.101 134.498 80.3413V43.6602C134.498 49.4199 104.389 54.0891 67.2488 54.0891Z",
    fill: "url(#paint16_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 67.1973V80.3413C0 86.1011 30.1082 90.7702 67.2489 90.7702C104.389 90.7702 134.498 86.1011 134.498 80.3413V67.1973H0Z",
    fill: "url(#paint17_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2845 75.6035V86.3511C9.82079 85.8101 7.68099 85.2322 5.9082 84.6209V75.5865C5.9082 73.5296 7.8424 72.0236 9.83616 72.529C9.85867 72.5348 9.88118 72.5403 9.90369 72.546C11.3031 72.8993 12.2845 74.1602 12.2845 75.6035Z",
    fill: "url(#paint18_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8982 78.4782V88.9099C26.6728 88.6683 24.5453 88.4086 22.5247 88.1273V78.4703C22.5247 76.5794 24.1747 75.1127 26.0518 75.3384C26.0732 75.3409 26.0947 75.3436 26.1161 75.3461C27.7022 75.5366 28.8982 76.8811 28.8982 78.4782Z",
    fill: "url(#paint19_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.515 79.9459V90.2156C43.3387 90.0995 41.211 89.968 39.1384 89.8181V79.9418C39.1384 78.1254 40.6677 76.6815 42.4806 76.7932C42.5028 76.7946 42.5253 76.7959 42.5476 76.7973C44.2136 76.8997 45.515 78.2769 45.515 79.9459Z",
    fill: "url(#paint20_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1285 80.6001V90.7408C59.9734 90.7164 57.8459 90.6766 55.752 90.6186V80.599C55.752 78.8359 57.1972 77.4117 58.9601 77.4449C58.9824 77.4455 59.0049 77.4457 59.0271 77.4463C60.7483 77.4784 62.1285 78.8787 62.1285 80.6001Z",
    fill: "url(#paint21_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7455 80.599V90.6186C76.6515 90.6768 74.5241 90.7164 72.3689 90.7408V80.6001C72.3689 78.879 73.7491 77.4784 75.47 77.4463C75.4923 77.4457 75.5148 77.4455 75.537 77.4449C77.3002 77.4114 78.7455 78.8356 78.7455 80.599Z",
    fill: "url(#paint22_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3593 79.9418V89.8181C93.2867 89.968 91.1593 90.0992 88.9827 90.2156V79.9459C88.9827 78.2769 90.2841 76.8997 91.9501 76.7973C91.9724 76.7959 91.9949 76.7946 92.0171 76.7932C93.83 76.6815 95.3593 78.1254 95.3593 79.9418Z",
    fill: "url(#paint23_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.973 78.47V88.127C109.952 88.4083 107.825 88.668 105.599 88.9096V78.4779C105.599 76.8806 106.795 75.5363 108.381 75.3461C108.403 75.3436 108.424 75.3409 108.446 75.3384C110.323 75.1127 111.973 76.5794 111.973 78.47Z",
    fill: "url(#paint24_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.59 75.5865V84.6209C126.817 85.2322 124.677 85.8101 122.213 86.3511V75.6035C122.213 74.1602 123.195 72.8993 124.594 72.546C124.617 72.5403 124.64 72.5348 124.662 72.529C126.656 72.0236 128.59 73.5296 128.59 75.5865Z",
    fill: "url(#paint25_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8483 68.6906C73.0165 68.6906 53.6968 73.3598 53.6968 79.1195V115.801C53.6968 110.041 73.0165 105.372 96.8483 105.372C120.68 105.372 140 100.703 140 94.9431V58.2617C140 64.0215 120.68 68.6906 96.8483 68.6906Z",
    fill: "url(#paint26_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8482 105.372C99.2269 105.372 101.56 105.325 103.834 105.235L85.4363 86.8379H84.4429V105.81C88.3725 105.525 92.536 105.372 96.8482 105.372Z",
    fill: "url(#paint27_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9397 87.7234C65.2813 85.8438 53.697 82.6916 53.697 79.1191V115.801C53.697 119.373 65.2813 122.525 82.9397 124.405V87.7234Z",
    fill: "url(#paint28_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.697 103.064V115.801C53.697 119.373 65.2813 122.526 82.9397 124.405V103.064H53.697Z",
    fill: "url(#paint29_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.313 121.659C70.0362 122.735 76.0183 123.668 82.9398 124.405V87.7237C76.0183 86.987 70.0362 86.0542 65.313 84.9775V121.659Z",
    fill: "url(#paint30_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7149 110.299V121.279C61.1167 120.628 58.9709 119.931 57.3386 119.194V110.281C57.3386 108.227 59.2736 106.719 61.2666 107.224C61.288 107.23 61.3124 107.236 61.3338 107.242C62.7338 107.593 63.7149 108.856 63.7149 110.299Z",
    fill: "url(#paint31_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0491 113.172V123.565C73.7808 123.25 71.6504 122.911 69.6755 122.55V113.166C69.6755 111.274 71.3262 109.807 73.203 110.033L73.2672 110.042C74.8539 110.232 76.0491 111.576 76.0491 113.172Z",
    fill: "url(#paint32_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.157 126.194H81.4183C80.6271 126.194 79.9856 125.553 79.9856 124.762V87.6846C79.9856 86.8935 80.6271 86.252 81.4183 86.252H84.157C84.9482 86.252 85.5897 86.8935 85.5897 87.6846V124.762C85.5897 125.553 84.9482 126.194 84.157 126.194Z",
    fill: "url(#paint33_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.131 94.7661V105.291C100.402 105.343 98.6367 105.37 96.8497 105.37C96.4846 105.37 96.1195 105.37 95.7544 105.373V94.7689C95.7544 93.0998 97.0556 91.7218 98.7218 91.6202C98.7438 91.6202 98.7658 91.6175 98.7877 91.6175C100.602 91.5049 102.131 92.9489 102.131 94.7661Z",
    fill: "url(#paint34_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.744 93.2947V103.929C116.721 104.22 114.588 104.47 112.37 104.676V93.3029C112.37 91.7053 113.567 90.3602 115.151 90.1707L115.217 90.1625C117.095 89.9374 118.744 91.4033 118.744 93.2947Z",
    fill: "url(#paint35_linear_2556_2272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.361 90.4093V99.6521C133.645 100.47 131.496 101.225 128.984 101.903V90.4286C128.984 88.9846 129.967 87.7219 131.367 87.3705C131.389 87.365 131.411 87.3595 131.433 87.354C133.425 86.8462 135.361 88.3533 135.361 90.4093Z",
    fill: "url(#paint36_linear_2556_2272)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2556_2272",
    x1: 138.854,
    y1: 58.4606,
    x2: 134.564,
    y2: 58.4606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DBAF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A86BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2556_2272",
    x1: 67.2489,
    y1: 35.1011,
    x2: 67.2489,
    y2: 56.9096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DBAF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076EBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2556_2272",
    x1: 67.2489,
    y1: 18.4231,
    x2: 67.2489,
    y2: 36.3656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DBAF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076EBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2556_2272",
    x1: 77.5404,
    y1: 25.4651,
    x2: 67.4527,
    y2: 25.4651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#076EBD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076EBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2556_2272",
    x1: 40.3931,
    y1: 24.064,
    x2: 39.0685,
    y2: 34.6609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DBAF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DBAF4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2556_2272",
    x1: 52.882,
    y1: 26.4964,
    x2: 67.787,
    y2: 26.4964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DBAF4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DBAF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2556_2272",
    x1: 64.1921,
    y1: 26.4913,
    x2: 68.4124,
    y2: 26.4913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5DBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2556_2272",
    x1: 67.2489,
    y1: 33.2612,
    x2: 67.2489,
    y2: 45.8458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DBAF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076EBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2556_2272",
    x1: 67.2489,
    y1: 45.8002,
    x2: 67.2489,
    y2: 60.2704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#076EBD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076EBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2556_2272",
    x1: 21.8779,
    y1: 48.346,
    x2: 27.6089,
    y2: 54.0769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F73A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A2F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2556_2272",
    x1: 38.4335,
    y1: 49.8659,
    x2: 44.1131,
    y2: 55.5455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F73A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A2F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2556_2272",
    x1: 55.0088,
    y1: 50.5541,
    x2: 60.6467,
    y2: 56.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F73A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A2F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2556_2272",
    x1: 71.5945,
    y1: 50.5824,
    x2: 77.1923,
    y2: 56.1802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F73A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A2F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2556_2272",
    x1: 88.1726,
    y1: 49.9556,
    x2: 93.7243,
    y2: 55.5073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F73A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A2F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2556_2272",
    x1: 104.743,
    y1: 48.5227,
    x2: 110.223,
    y2: 54.0027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F7AB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003E6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2556_2272",
    x1: 67.2489,
    y1: 53.136,
    x2: 67.2489,
    y2: 68.4322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DBAF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#138CE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2556_2272",
    x1: 96.6556,
    y1: 60.3709,
    x2: 106.234,
    y2: 87.2707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0138794,
    stopColor: "#6DBAF4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DBAF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2556_2272",
    x1: 67.2489,
    y1: 74.5338,
    x2: 67.2489,
    y2: 93.6897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#076EBD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076EBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2556_2272",
    x1: 5.42452,
    y1: 75.7874,
    x2: 11.2592,
    y2: 81.6222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F73A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A2F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2556_2272",
    x1: 21.8779,
    y1: 78.8167,
    x2: 27.6089,
    y2: 84.5476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F73A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A2F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2556_2272",
    x1: 38.4335,
    y1: 80.3366,
    x2: 44.1131,
    y2: 86.0162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F73A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A2F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2556_2272",
    x1: 55.0086,
    y1: 81.0248,
    x2: 60.6465,
    y2: 86.6627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F73A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A2F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2556_2272",
    x1: 71.5942,
    y1: 81.0528,
    x2: 77.192,
    y2: 86.6509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F73A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A2F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2556_2272",
    x1: 88.1726,
    y1: 80.4263,
    x2: 93.7243,
    y2: 85.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F73A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A2F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2556_2272",
    x1: 104.742,
    y1: 78.9924,
    x2: 110.223,
    y2: 84.4724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F7AB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003E6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2556_2272",
    x1: 121.262,
    y1: 76.1762,
    x2: 126.544,
    y2: 81.4577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F73A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A2F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2556_2272",
    x1: 95.752,
    y1: 74.8333,
    x2: 98.1976,
    y2: 102.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DBAF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076EBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2556_2272",
    x1: 96.2882,
    y1: 96.3238,
    x2: 73.667,
    y2: 96.3238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DBAF4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#138CE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2556_2272",
    x1: 68.3182,
    y1: 88.2282,
    x2: 68.3182,
    y2: 102.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#138CE8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076EBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2556_2272",
    x1: 68.6002,
    y1: 112.015,
    x2: 66.5622,
    y2: 124.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#076EBD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076EBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2556_2272",
    x1: 71.4266,
    y1: 104.691,
    x2: 82.8838,
    y2: 104.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#076EBD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076EBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2556_2272",
    x1: 56.8923,
    y1: 110.459,
    x2: 62.8003,
    y2: 116.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F73A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A2F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2556_2272",
    x1: 69.0952,
    y1: 113.442,
    x2: 74.8138,
    y2: 119.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F73A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A2F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2556_2272",
    x1: 80.4951,
    y1: 106.223,
    x2: 84.7154,
    y2: 106.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFD1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5DBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2556_2272",
    x1: 94.8784,
    y1: 95.3511,
    x2: 100.636,
    y2: 101.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F73A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A2F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2556_2272",
    x1: 111.306,
    y1: 94.0792,
    x2: 117.095,
    y2: 99.8689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F73A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A2F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2556_2272",
    x1: 127.857,
    y1: 91.1878,
    x2: 133.204,
    y2: 96.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F73A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A2F4D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2556_2272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasuringTape);
export default __webpack_public_path__ + "static/media/measuring-tape.c7f12d09f4d44ce0e0b23e14fa369746.svg";
export { ForwardRef as ReactComponent };